/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * jsdoc: not yet commented
 */
import config from "../config";
import log4javascript from "log4javascript/log4javascript_uncompressed";
log4javascript.setEnabled(config.log.enable);
import {
	notifyProgrammingError,
	logError,
	logWarn,
	logInfo,
	logDebug,
	logTrace,
	addConsoleLogAppender
} from "../utils/LogAndErrorManager";
window.log4javascript = log4javascript;
window.notifyProgrammingError = notifyProgrammingError;
window.logError = logError;
window.logWarn = logWarn;
window.logInfo = logInfo;
window.logDebug = logDebug;
window.logTrace = logTrace;

function setLogLevel(logger, string) {
	const log4JSlogLevelMap = {
		"all": log4javascript.Level.ALL,
		"trace": log4javascript.Level.TRACE,
		"debug": log4javascript.Level.DEBUG,
		"info": log4javascript.Level.INFO,
		"warn": log4javascript.Level.WARN,
		"error": log4javascript.Level.ERROR,
		"fatal": log4javascript.Level.FATAL,
		"off": log4javascript.Level.OFF,
		"true": log4javascript.Level.ALL,
		"false": log4javascript.Level.OFF,
	};
	let level = log4JSlogLevelMap[string.toLowerCase()];
	if (!level) {
		level = log4javascript.Level.OFF;
	}
	logger.setLevel(level);
}

const log = log4javascript.getLogger("MAIN");
setLogLevel(log, config.log.level);
window.log = log;

const logping = log4javascript.getLogger("NETWORK");
setLogLevel(logping, config.log.pingLevel);
window.logping = logping;

addConsoleLogAppender();
// todo add ajax appender

export { log, logping, log4javascript };